module.exports = __webpack_public_path__ + "static/media/reactstrap.10ff2bba.png";